// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"68":"78c94323c5d63989","497":"dfe7ce0d12d99513"}[chunkId] + ".js";
};